import { render, staticRenderFns } from "./SuccessFakePspModal.vue?vue&type=template&id=65527a70&scoped=true"
import script from "./SuccessFakePspModal.vue?vue&type=script&lang=js"
export * from "./SuccessFakePspModal.vue?vue&type=script&lang=js"
import style0 from "./SuccessFakePspModal.vue?vue&type=style&index=0&id=65527a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65527a70",
  null
  
)

export default component.exports